import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Button, { ButtonStyle } from '../Button/Button';
import { useTranslation } from 'react-i18next';
import { encodeExportBooklet } from './BookletExport/BookletExport';
import styles from './Booklets.module.scss';

const DownloadPDFButton = ({ internalId, isDisabled }) => {
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(false);
    const apiUrl = process.env.REACT_APP_API_URL;

    const handleDownload = async () => {
        try {
            setIsLoading(true);
            const exportUrl = `${
                apiUrl.endsWith('/') ? apiUrl.slice(0, -1) : apiUrl
            }/export/${encodeExportBooklet(internalId)}`;

            const response = await fetch(exportUrl, {
                headers: {
                    Accept: 'application/pdf',
                },
            });

            if (!response.ok) {
                throw new Error('Download failed');
            }

            const contentDisposition = response.headers.get('Content-Disposition');

            let filename = `booklet_${internalId}.pdf`;

            if (contentDisposition) {
                const filenameMatch = contentDisposition.match(/filename="?([^"]+)"?/);
                if (filenameMatch && filenameMatch[1]) {
                    filename = filenameMatch[1];
                }
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(link);
        } catch (error) {
            console.error('Error downloading PDF:', error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Button
            style={ButtonStyle.PRIMARY}
            text={isLoading ? t('booklet.generatingPdf') : t('booklet.DownloadPDF')}
            disabled={isDisabled || isLoading}
            icon={isLoading ? 'pulse-rings' : 'downloads'}
            onClick={handleDownload}
            extraClasses={styles.DownloadPdfButton}
        />
    );
};

DownloadPDFButton.propTypes = {
    internalId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    isDisabled: PropTypes.bool,
};

export default DownloadPDFButton;
